export const OPERATION_TYPE = {
    1: "Azure Download",
    2: "File Copy",
    3: "Image Resizer",
    4: "Stereo Check",
    5: "Media Info",
    6: "Delete Source",
    7: "Transcode",
    8: "Move to Processed",
    9: "Upload",
    10: "Notify Submission Site"
}